var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContentLayout',{attrs:{"columnsSubList":_vm.columnsSubList}},[_c('template',{slot:"content"},[_c(_vm.pageCmp,{tag:"component"})],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }